import {StaffHospitalInfo} from './StaffHospitalInfo';

export class StaffInformation {
  informationChangesNotedBelow?: boolean;
  memberBoard?: string;
  unrestrictedPrivileges?: boolean;
  privileges?: string;
  fte?: boolean;
  hoursPerWeek?: number;
  painManagement?: boolean = false;
  staffHospitalInformation?: StaffHospitalInfo[] = [];
  ownership?: number;
}
